import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  { path: '/', name: 'LandingPage', component: () => import('../pages/LandingPage.vue') },
  { path: '/services', name: 'ServicesPage', component: () => import('../pages/ServicesPage.vue') },
  { path: '/business-advisory', name: 'BusinessAdvisory', component: () => import('../pages/BusinessAdvisory.vue') },
  { path: '/digital', name: 'DigitalPage', component: () => import('../pages/DigitalPage.vue') },
  { path: '/insight', name: 'InsightPage', component: () => import('../pages/InsightPage.vue') },
  { path: '/about', name: 'AboutPage', component: () => import('../pages/AboutPage.vue') },
  { path: '/contact', name: 'Contactus', component: () => import('../pages/ContactForm.vue') },
  { path: '/meet', name: 'Meetus', component: () => import('../pages/MeetingPage.vue') },

  { path: '/itServices', name: 'itServices', component: () => import('../pages/TechPage.vue') },

  { path: '/self-sponsorship', name: 'SelfSponsorship', component: () => import('../pages/SelfSponsorshipPage.vue') },
  { path: '/sponsorship-license', name: 'SponsorshipLicense', component: () => import('../pages/SponsorshipLicensePage.vue') },
  { path: '/schengen-visa', name: 'SchengenVisa', component: () => import('../pages/SchengenVisaPage.vue') },
  { path: '/self-sponsorship-ecommerce', name: 'SelfSponsorshipEcommerce', component: () => import('../pages/SelfSponsorshipEcommercePage.vue') }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
